// extracted by mini-css-extract-plugin
module.exports = {"verticalDivider":"Dividers_verticalDivider__y1ZZ5","horizontalDivider":"Dividers_horizontalDivider__yRj54"};